<div class="ag-overlay-loading-center">
    <div class="icon-container" [innerHTML]="svg"></div>
    <div class="no-rows-message">{{ params.noRowsMessage }}</div>
</div>
